import { HeadingMedium, Label1 } from 'baseui/typography';
import React from 'react';
import { connect } from 'react-redux';
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import { formatter } from '../../calculations/SocialSecurityApi';
import { getMaritalStatus } from '../../calculations/userDataTransformer';

const makeDataForYear = (takeAgeJack, takeAgeJill, baseAmountJack, baseAmountJill, age) => {
    return {
        age: age,
        year: 2029 + (age - 70),
        jack: (age - takeAgeJack) * baseAmountJack,
        jill: (age - takeAgeJill) * baseAmountJill,
    }
}

export const CumulativeJointGraph = ({ jackAmount, jillAmount, mainUserName, spouseUserName, maritalStatus, width=1000, height=500  }) => {
    return <div style={{ width: width + 100, justifyContent: 'center', margin: 50 }}>
        <HeadingMedium>Cumulative Comparison</HeadingMedium>

        <Label1>Below is a chart with the amount we project you will receive, based on the options you have chosen.</Label1>
        <br></br>
        <BarChart
            width={width}
            height={height}
            data={[70, 75, 80, 85, 90, 95, 100].map(e => makeDataForYear(62, 65, jackAmount, jillAmount, e))}
            margin={{
                top: 5, right: 0, left: 40, bottom: 5,
            }}
        >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis tickFormatter={(value) => '$' + formatter.format(value)} />
            <Tooltip formatter={(value) => '$' + formatter.format(value)} />
            <Legend />
            <Bar dataKey="jack" fill="#8884d8" name={mainUserName + " - $" + formatter.format(jackAmount) + "/yr"} stackId={1} />
            {maritalStatus === 'married' ? <Bar dataKey="jill" fill="#a832a6" name={spouseUserName + " - $" + formatter.format(jillAmount) + "/yr"} stackId={1} /> : undefined}
        </BarChart>
    </div>
}

export default connect(state => ({
    mainUserName: state.userData.answers.mainUserName,
    spouseUserName: state.userData.answers.spouseUserName,
    maritalStatus: getMaritalStatus(state.userData.answers)
}), {})(CumulativeJointGraph);